export function Welcome() {
  return (
    <section className="bg-white py-16 lg:py-20">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
          WELCOME TO SIMSBURY AIRPORT (4B9)
        </h2>
        
        <h3 className="text-xl md:text-2xl text-gray-700 mb-8 font-medium">
          A Historic Airport in the Connecticut Foothills
        </h3>
        
        <div className="text-gray-600 text-lg leading-relaxed max-w-3xl mx-auto">
          <p>
            Simsbury Airport is situated in the picturesque Connecticut foothills in north central Connecticut. 
            It is operated by the Simsbury Airport Association which is a non-profit 501(c)(3) dedicated to the 
            preservation of this historic airport. Building on a legacy of over 75 years, the airport continues 
            to serve the aviation community and provide a gateway to the scenic Connecticut countryside.
          </p>
        </div>
      </div>
    </section>
  );
}